import React, { createContext, useContext, useState, useCallback } from 'react';

const DevModeContext = createContext();

export const useDevMode = () => {
  const context = useContext(DevModeContext);
  if (!context) {
    throw new Error('useDevMode must be used within DevModeProvider');
  }
  return context;
};

export const DevModeProvider = ({ children }) => {
  const [isDevMode, setIsDevMode] = useState(false);

  const toggleDevMode = useCallback(() => {
    setIsDevMode(prev => !prev);
  }, []);

  const value = {
    isDevMode,
    toggleDevMode,
    setIsDevMode
  };

  return (
    <DevModeContext.Provider value={value}>
      {children}
    </DevModeContext.Provider>
  );
};

